<template>
  <div>
    <div class="product-leg-selector">
      <ImageOptionCard
        v-for="(option, index) in sortedOptions"
        :key="index"
        :option="option"
        :is-active="option.sku_code == activeOption.sku_code"
        type="leg"
        @click="handleOptionClick(option)"
      />
    </div>
  </div>
</template>
<script>
import ImageOptionCard from "./ImageOptionCard.vue";
export default {
  name: "ProductLegSelector",
  components: {
    ImageOptionCard,
  },
  props: {
    legOptions: Array,
    selectedProduct: Object,
  },
  computed: {
    shippingString() {
      if (!this.IGNORE_SHIPPING_FABRICS.includes(this.selectedProduct.fabric)) {
        return "Timeline Available After Material is Selected";
      }
      let activeBaseTime = parseInt(this.shipping.all);
      if (this.shipping[this.selectedProduct.sku]) {
        activeBaseTime = parseInt(this.shipping[this.selectedProduct.sku]);
      }
      let timeString = `${activeBaseTime} Days`;
      if (activeBaseTime > 14) {
        timeString = `${Math.ceil(activeBaseTime / 7)} Weeks`;
      }
      return `Made in ${timeString}`;
    },
    sortedOptions() {
      // Groupings delineated with ()
      const hasGrouping = this.options.find((option) => option.title.includes('('))
      if (hasGrouping) {
        const sorted = []
        const ungrouped = []
        const grouped = []
        const groups = []
        this.options.forEach((option) => {
          if (option.title.includes('(')) {
            const group = option.title.split('(')[1].trim()
            if (!groups.includes(group)) {
              groups.push(group)
            }
            const optionCopy = {...option}
            optionCopy.group = group
            grouped.push(optionCopy)
          } else {
            ungrouped.push(option)
          }
        })
        groups.sort(this.sortTitles).forEach((group) => {
          const groupOptions = grouped.filter((option) => option.title.includes(group))
          groupOptions.sort(this.reverseSortTitles)
          sorted.push(...groupOptions)
        })
        ungrouped.sort(this.reverseSortTitles)
        sorted.push(...ungrouped)
        return sorted
      }
      return [...this.options].sort(this.reverseSortTitles)
    }
  },
  data() {
    return {
      options: this.legOptions || [],
      IGNORE_SHIPPING_FABRICS: ["Decide Later", "Customer Own Materials"],
      activeOption: {}
    };
  },
  mounted() {
    const searchParams = new URLSearchParams(window.location.search);
    const setLeg = searchParams.get("leg");
    this.options.forEach((option) => {
      if (option.title.trim() == setLeg.trim()) {
        this.activeOption = option
      }
    });
  },
  methods: {
    handleOptionClick(option) {
      if (this.activeOption != option) {
        this.activeOption = option
        this.$emit("leg-changed", this.activeOption);
      }
    },
    sortTitles(a, b) {
      return (a.title < b.title) ? -1 : (a.title > b.title) ? 1 : 0;
    },
    reverseSortTitles(a, b) {
      return (a.title > b.title) ? -1 : (a.title < b.title) ? 1 : 0;
    },
  },
};
</script>
<style scoped>
.product-leg-selector {
  display: grid;
  grid-template-columns: repeat(3, 90px);
  gap: 16px;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
